import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_15 = {
  key: 0,
  class: "card mt-9"
}
const _hoisted_16 = { class: "card-header" }
const _hoisted_17 = {
  class: "card-title d-flex align-item-center justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_18 = { class: "d-flex align-item-center fs-3 fw-semobold" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_21 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", null, "Active", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  colspan: "9",
  class: "fw-semibold pt-7 pb-0"
}
const _hoisted_25 = { class: "d-flex justify-content-between" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "p-0" }
const _hoisted_28 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }
const _hoisted_29 = ["checked"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-semobold text-muted" }, null, -1)
const _hoisted_31 = { class: "p-0" }

import { ref, onMounted, watch } from "vue";
import { ElNotification } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TableFooter from "@/components/TableFooter.vue";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import walletDetail from "@/projects/tenant/modules/users/components/modal/walletDetail.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserWallets',
  props: {
    partyId: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(true);
const hideActive = ref(false);
const deposit = ref({} as any);
const withdraw = ref({} as any);
const paymentMethodsWalletId = ref(0);
const userWallets = ref(Array<any>());
const gettingPaymentMethod = ref(false);
const walletPaymentMethods = ref({} as any);
const walletPaymentServices = ref(Array<any>());
const walletDetailRef = ref<InstanceType<typeof walletDetail>>();

const criteria = ref({
  partyId: props.partyId,
  page: 1,
  size: 10,
} as any);

const getWallets = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;

  try {
    const responseBody = await TenantGlobalService.queryWallets(criteria.value);
    userWallets.value = responseBody.data;
    criteria.value = responseBody.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const viewWalletTransactions = (walletId: number, currencyId: number) => {
  walletDetailRef.value?.show(walletId, currencyId);
};

const paymentMethodChanged = async (_item: any) => {
  try {
    if (_item.accessStatus) {
      await PaymentService.putEnableWalletPaymentMethodById(
        _item.id,
        paymentMethodsWalletId.value
      );
    } else {
      await PaymentService.putDisableWalletPaymentMethodById(
        _item.id,
        paymentMethodsWalletId.value
      );
    }

    ElNotification({
      title: _item.name,
      message: "Payment method updated successfully",
      type: "success",
    });
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: "Error Submit",
      type: "error",
    });
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const getPaymentMethods = async (_id) => {
  gettingPaymentMethod.value = true;
  paymentMethodsWalletId.value = _id;

  try {
    walletPaymentMethods.value =
      await PaymentService.getWalletPaymentMethodById(_id);

    var tempDeposit = walletPaymentMethods.value.deposit;
    tempDeposit = tempDeposit.reduce((index, item) => {
      if (index[item.group]) {
        index[item.group].push(item);
      } else {
        index[item.group] = [item];
      }
      return index;
    }, {});
    Object.keys(tempDeposit)
      .sort()
      .forEach((group) => {
        deposit.value[group] = tempDeposit[group];
      });

    var tempwithdrawal = walletPaymentMethods.value.withdrawal;
    tempwithdrawal = tempwithdrawal.reduce((index, item) => {
      if (index[item.group]) {
        index[item.group].push(item);
      } else {
        index[item.group] = [item];
      }
      return index;
    }, {});

    Object.keys(tempwithdrawal)
      .sort()
      .forEach((group) => {
        withdraw.value[group] = tempwithdrawal[group];
      });

    walletPaymentServices.value = withdraw.value;
    gettingPaymentMethod.value = false;
  } catch (error) {
    MsgPrompt.error(error);
  }
};

watch(hideActive, (value) => {
  if (value) {
    walletPaymentServices.value = Object.keys(walletPaymentServices.value)
      .filter((group) => {
        return walletPaymentServices.value[group].some((item) => {
          return item.status == 10;
        });
      })
      .reduce((index, group) => {
        index[group] = walletPaymentServices.value[group].filter((item) => {
          return item.status == 10;
        });
        return index;
      }, {});
  } else {
    getPaymentMethods(paymentMethodsWalletId.value);
  }
});

onMounted(() => {
  getWallets(1);
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.userWallets")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.currency")), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.fundType")), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.amount")), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && userWallets.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userWallets.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.id), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.fundType.${item.fundType}`)), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_BalanceShow, {
                            "currency-id": item.currencyId,
                            balance: item.balance
                          }, null, 8, ["currency-id", "balance"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (viewWalletTransactions(item.id, item.currencyId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`action.viewTransactions`)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (getPaymentMethods(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Set Payment Methods")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(TableFooter, {
            onPageChange: getWallets,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ])
      ]),
      (paymentMethodsWalletId.value != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_18, " Wallet Withdraw Methods ( ID: " + _toDisplayString(paymentMethodsWalletId.value) + " ) ", 1)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_switch, {
                    modelValue: hideActive.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hideActive).value = $event)),
                    "active-text": "Show Active Only",
                    "inactive-text": "Show All",
                    "inactive-color": "#13ce66",
                    class: "me-5",
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("table", _hoisted_20, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_21, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.serviceActive")), 1),
                    _hoisted_22
                  ])
                ]),
                (gettingPaymentMethod.value)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                      _createVNode(_component_LoadingRing)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(walletPaymentServices.value, (value, i) => {
                      return (_openBlock(), _createElementBlock("tbody", {
                        key: i,
                        class: "fw-semibold tbodyBorder"
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("h4", null, _toDisplayString(i), 1)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_26, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["p-3", item.status ? '' : 'bg-warning rounded'])
                              }, _toDisplayString(item.name) + " " + _toDisplayString(item.id), 3)
                            ]),
                            _createElementVNode("td", _hoisted_27, [
                              _createElementVNode("label", _hoisted_28, [
                                _createElementVNode("input", {
                                  class: "form-check-input center-switch",
                                  name: "activate",
                                  type: "checkbox",
                                  checked: item.status,
                                  disabled: true
                                }, null, 8, _hoisted_29),
                                _hoisted_30
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_31, [
                              (item.status)
                                ? (_openBlock(), _createBlock(_component_el_switch, {
                                    key: 0,
                                    modelValue: item.accessStatus,
                                    "onUpdate:modelValue": ($event: any) => ((item.accessStatus) = $event),
                                    "active-value": 10,
                                    "inactive-value": 0,
                                    class: "me-5",
                                    disabled: isLoading.value,
                                    onChange: ($event: any) => (paymentMethodChanged(item))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(walletDetail, {
      ref_key: "walletDetailRef",
      ref: walletDetailRef
    }, null, 512)
  ], 64))
}
}

})